// extracted by mini-css-extract-plugin
export default {"Cell":"_Cell--YdoVP","Drop":"_Drop--xkKIO","Active":"_Active--SruJa","Over":"_Over--HURot"};